import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
// Components
import { withNamespaces } from "react-i18next";
import Card from "../../../components/Card";
// Ducks
import { navigateTo } from "../Dashboard.ducks";
import { getVouchers } from "./Vouchers.ducks";
import { fetchAppFeatureSettings } from "../../../services/clientSettings.ducks";

// Styles
import styles from "./Vouchers.css";
import NoInformation from "../../../components/NoInformation";

class Vouchers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasActiveVoucherSystem: true
    };
  }

  async componentDidMount() {
    const { getVouchers, fetchAppFeatureSettings } = this.props;

    const appFeatureSettings = await fetchAppFeatureSettings();

    this.setState({
      hasActiveVoucherSystem: appFeatureSettings.hasActiveVoucherSystem
    });

    if (appFeatureSettings.hasActiveVoucherSystem) {
      getVouchers();
    } else {
      navigateTo("/dashboard/bookings");
      return <></>;
    }
  }

  handleNewBooking = () => {
    const { navigateTo } = this.props;

    navigateTo("/dashboard");
  };

  render() {
    const {
      t,
      vouchers: { vouchers }
    } = this.props;

    const { hasActiveVoucherSystem } = this.state;

    if (!hasActiveVoucherSystem) {
      navigateTo("/dashboard/bookings");
      return <></>;
    }

    return (
      <div className="container" style={{ paddingBottom: 40 }}>
        <div style={styles.headerContainer}>
          <h1 style={styles.pageTitle} className="txt-color-blue">
            {t("modules.localization.register.authenticated.vouchers.myVouchers")}
          </h1>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.handleNewBooking}
            style={styles.button}
          >
            {t("modules.localization.register.authenticated.vouchers.bookNow")}
          </button>
        </div>
        <div style={styles.cardContainer}>
          {vouchers && !vouchers.length && (
            <NoInformation
              label={t("modules.localization.register.authenticated.vouchers.emptyVouchers")}
            />
          )}
          {vouchers &&
            vouchers.map((voucher, index) => (
              <Card
                key={voucher.code}
                allowCopy={!voucher.isExpired}
                description={
                  voucher.isExpired
                    ? t("modules.localization.register.authenticated.vouchers.voucherAlreadyUsed")
                    : ""
                }
                mainDescription={voucher.code}
                strikeThrough={voucher.isExpired}
                title={t("modules.localization.register.authenticated.vouchers.voucher", {
                  number: index + 1
                })}
                value={voucher.amount}
                tooltipMessage={t(
                  "modules.localization.register.authenticated.vouchers.copyVoucherCode"
                )}
              />
            ))}
        </div>
      </div>
    );
  }
}

Vouchers.propTypes = {
  getVouchers: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
  fetchAppFeatureSettings: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  vouchers: PropTypes.shape({
    vouchers: PropTypes.shape({
      map: PropTypes.func,
      length: PropTypes.number
    }),
    amount: PropTypes.string,
    code: PropTypes.string,
    isExpired: PropTypes.bool
  }).isRequired
};

const mapStateToProps = (state) => ({
  vouchers: state.vouchers
});

const mapDispatchToProps = {
  getVouchers,
  navigateTo,
  fetchAppFeatureSettings
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(Vouchers);
